module.exports = __webpack_public_path__ + "static/media/how_pl.583efe47.vtt";